module.exports = __webpack_public_path__ + "img/circle-flyer.4237ef2b.svg";